import * as React from "react";

function SvgRecMobileHeaderMousikomi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
      <circle cx={11} cy={11} r={11} fill="#fff" />
      <g fill="#f2a7b3">
        <path d="M8.856 15.867l.043-.043 4.621-4.621.048-.048.048-.048 2.448-2.448v-.002l-2.732-2.733h-.002l-2.448 2.449-.048.048-.048.047-4.665 4.665-1.196 3.929.002.001 3.87-1.178zm-3.059.323l.597-1.962h.002l1.365 1.365v.002l-1.962.597zM16.847 7.404a.783.783 0 000-1.105l-1.134-1.134a.783.783 0 00-1.105 0l-.566.566v.002l2.237 2.237h.001z" />
      </g>
    </svg>
  );
}

export default SvgRecMobileHeaderMousikomi;
